import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=014bd76a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bd76a",
  null
  
)

component.options.__file = "Index.vue"
export default component.exports